<script>
  import {
    parseDataAddressData,
    convertAddressObjectToMapData,
    compareTwoAddress,
    resolveAddressMapObjectDefault,
  } from '@utils/format-address';
  import { ensureOnePrimary } from '@utils/contact';
  import {
    resolveTypeOrderedIndex,
    resolveDocumentTypeByCode,
    resolveDocumentDenominationTotal,
    resolveDocumentTotal,
    resolveEditPermissionsForDocumentByType,
    resolveContactForDocument,
    resolveRouterObjectForDocument,
    resolveTypeForDocument,
    resolveDocumentKeyForSnakeCase,
  } from '@utils/document';
  import { importMapApiScript } from '@utils/main';

  export default {
    methods: {
      importMapApiScript,
      parseDataAddressData,
      convertAddressObjectToMapData,
      compareTwoAddress,
      resolveTypeOrderedIndex,
      resolveAddressMapObjectDefault,
      resolveDocumentDenominationTotal,
      resolveDocumentTotal,
      resolveRouterObjectForDocument,
      resolveDocumentTypeByCode,
      resolveContactForDocument,
      resolveEditPermissionsForDocumentByType,
      resolveTypeForDocument,
      resolveDocumentKeyForSnakeCase,
      ensureOnePrimary,
      notifyErrors(response) {
        if (response.data && response.data.error) {
          if (response.data.error.extra) {
            this.errors = response.data.error.extra.invalid_parameters
          }
          this.$toasted.toast(response.data.error.message, {
            title: 'Error',
            variant: 'danger', colour: 'red',
          })
        }
      },
      notifySuccess(title, message) {
        this.$toasted.toast(message, {
          title: title,
          variant: 'success', colour: 'green',
        })
      },
    },
  }
</script>
